import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from "vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import SvgQuestion from "@/assets/icons/question-mark.svg";
import SvgQuestionBlue from "@/assets/icons/question-mark-blue.svg";
import SvgExclamation from "@/assets/icons/exclamation-rounded.svg";
import { useWindowResize } from "@/utils/useWindowSize";

interface Props {
    position?: 'top' | 'bottom' | 'left' | 'right';
    mobilePosition?: 'top' | 'bottom' | 'left' | 'right';
    color?: 'black' | 'blue';
    tooltip: string;
    width?: string;
    isHtml?: boolean;
    icon?: 'exclamation' | 'question' | 'question-blue';
    scrollSelector?: string;
    isInline?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseQuestionMarkTooltip',
  props: {
    position: { default: 'top' },
    mobilePosition: { default: 'top' },
    color: { default: 'blue' },
    tooltip: { default: '' },
    width: { default: '' },
    isHtml: { type: Boolean },
    icon: { default: 'question' },
    scrollSelector: { default: '.page-card' },
    isInline: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as { position: 'top' | 'bottom' | 'left' | 'right', mobilePosition: 'top' | 'bottom' | 'left' | 'right', color: 'black' | 'blue', tooltip: string, width: string, isHtml?: boolean, icon: 'exclamation' | 'question' | 'question-blue', scrollSelector: string, isInline?: boolean }



const tooltipComp = ref(null);
const { width } = useWindowResize();
let page = null;

onMounted(() => {
    page = document.querySelector(props.scrollSelector);
    page?.addEventListener('scroll', closeTooltip);
});

const closeTooltip = () => {
    tooltipComp.value.closeTooltip();
};

onUnmounted(() => {
    page?.removeEventListener('scroll', closeTooltip);
});

const getIcon = computed(() => {
    switch (props.icon) {
    case "question-blue":
        return SvgQuestionBlue;
    case "exclamation":
        return SvgExclamation;
    default:
        return SvgQuestion;
    }
});
const getPosition = computed(() => width.value < 1264 ? props.mobilePosition : props.position);

expose({
    closeTooltip,
});

return { __sfc: true,props, tooltipComp, width, page, closeTooltip, getIcon, getPosition, BaseTooltip }
}

})